export const drawerWidth = 440